(function () {
  if (window.__rrInitialized) return;
  window.__rrInitialized = true;

  var initializedSections = new WeakSet();

  function initCompareEl(compareEl) {
    var range = compareEl.querySelector('[data-rr-range]');
    if (!range) return;

    function setPos(value) {
      var v = Math.min(100, Math.max(0, value));
      compareEl.style.setProperty('--pos', v + '%');
    }

    setPos(range.value);

    range.addEventListener('input', function () {
      setPos(range.value);
    });

    compareEl.addEventListener('pointerdown', function (e) {
      if (e.target === range) return;
      var rect = compareEl.getBoundingClientRect();
      var pct = ((e.clientX - rect.left) / rect.width) * 100;
      range.value = pct;
      setPos(pct);
    });
  }

  function setActiveSlide(root, index) {
    var slides = root.querySelectorAll('[data-rr-slide]');
    var dots = root.querySelectorAll('[data-rr-dot]');

    slides.forEach(function (slide) {
      var isActive = parseInt(slide.getAttribute('data-index'), 10) === index;
      slide.classList.toggle('is-active', isActive);
    });

    dots.forEach(function (dot) {
      var isActive = parseInt(dot.getAttribute('data-index'), 10) === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(root);
  }

  function initSection(root) {
    if (!root || initializedSections.has(root)) return;
    initializedSections.add(root);

    root.querySelectorAll('[data-rr-compare]').forEach(initCompareEl);

    root.querySelectorAll('[data-rr-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        setActiveSlide(root, index);
      });
    });

    initReveal(root);
  }

  function initAll() {
    document.querySelectorAll('[data-real-results]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-real-results]');
    if (root) {
      initializedSections.delete(root);
      root.classList.remove('is-visible');
      initSection(root);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-real-results]');
    if (!root) return;
    var slide = event.target.closest('[data-rr-slide]');
    if (slide) {
      var index = parseInt(slide.getAttribute('data-index'), 10);
      setActiveSlide(root, index);
    }
  });
})();